import React, { useEffect, useState } from "react";
import { LoginModel } from "../../app/models/LoginModel";

import BrowserInfoModal from "./BrowserInfoModal";
import LoginBox from "./LoginBox";
import { Navigate, useParams } from "react-router";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react";
import AuthFooter from "./AuthFooter";
import ResetBox from "./ResetBox";
import logo from "../../assets/images/base-login.png";
import ResetTwoFABox from "./ResetTwoFABox";

export default observer(function ResetTwoFAPage() {
  const { token } = useParams<{ token: string }>();

  document.title = "Base - Reset Two Factor Authentication";

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <div className="login container">
        <div className="row oms-login-box">
          <div className="col-lg-4 col-md-3 col-sm-2"></div>
          <div className="col-lg-4 col-md-6 col-sm-8">
            <div className="tw-m-auto tw-flex tw-items-center tw-justify-center tw-pt-[20%]">
              <img src={logo} alt="Base" className="tw-mb-3 tw-h-[100px]" />
            </div>
            <ResetTwoFABox token={token}></ResetTwoFABox>
            <br />
            <br />
            <AuthFooter />
          </div>
          <div className="col-lg-4 col-md-3 col-sm-2"></div>
        </div>
      </div>
    </>
  );
});
